module.exports = __webpack_public_path__ + "static/media/calendar.20cbc4ba.svg";